module.exports = __webpack_public_path__ + "img/laddercontrolBanner.ea10f948.png";